<template>
  <div>
    <ComponentsList
      ref="componentsList"
      :value="config.specOptions"
      @edit="onInput"
      @editionStart="editionStart"
    />
  </div>
</template>

<script>
/**
 * Widget options panel. Display all provided options in order to setup a widget.
 *
 * @vue-event {VueComponent} editionStart - Emitted after created's nextTick and
 *                           when the config is set
 * @vue-event {Object} edit - Triggered on any edition of an item
 */
// Assets
import cloneDeep from 'lodash/cloneDeep';
// Components
import ComponentsList from '@/components/components-list.vue';

export default {
  name: 'WidgetConfigPanel',
  components: {
    ComponentsList,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      config: [],
    };
  },
  watch: {
    value(newVal, oldValue) {
      this.config = cloneDeep(newVal);
    },
  },
  created() {
    this.config = cloneDeep(this.value);
  },
  methods: {
    editionStart() {
      this.$nextTick(() => {
        this.$emit('editionStart', this);
      });
    },
    onInput(elem) {
      this.$emit('edit', elem);
    },
  },
};
</script>
